<aw-add-researchers-to-box [box]="data" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-add-researchers-to-box>